import { connect } from 'react-redux'
import { compose, withProps, withHandlers } from 'recompose'
import { actions, selectors } from 'reducers'
import _ from 'lodash/fp'

import constants from '../../constants'

const toRGBAString = color =>
  `rgba(${color.r},${color.g},${color.b},${color.a})`

const mapStateToProps = state => ({
  defaultContentId: state.collections.defaultContentId,
  selectedContentId:
    state.create.selectedContentId || state.collections.defaultContentId,
  contentIds: _.keys(state.collections.content),
  selectedContentColor: state.create.selectedContentColor,
  content: state.collections.content,
  selectingContentType: state.create.selectingContentType,
})

const mapDispatchToProps = {
  listen: actions.collections.listen,
  stopListening: actions.collections.stopListening,
  setOne: actions.collections.setOne,
  selectContentId: actions.create.selectContentId,
  selectNextContentId: actions.create.selectNextContentId,
  selectPrevContentId: actions.create.selectPrevContentId,
}

const createProps = props => ({
  canUpdate: props.defaultContentId !== props.selectedContentId,
  listen: () => props.listen('defaultContentId'),
  stopListening: () => props.stopListening('defaultContentId'),
  updateDefaultContentId: defaultContentId => {
    console.log('Updated default!')
    console.log('Selecting content type: ', props.selectingContentType)
    return
    props.setOne({
      collectionName: 'defaultContentId',
      value:
        props.selectingContentType ===
        constants.createNav.SELECT_CONTENT_TYPE_THEME
          ? props.selectedContentId
          : toRGBAString(props.selectedContentColor),
    })
  },
})

const handlers = {
  selectNextContentId: props => () =>
    props.selectNextContentId(props.contentIds),
  selectPrevContentId: props => () =>
    props.selectPrevContentId(props.contentIds),
  selectContentId: props => id => props.selectContentId(id),
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers(handlers),
  withProps(createProps),
)



// WEBPACK FOOTER //
// ./src/components/schedule-default/enhance.js